import { useQuery } from '@tanstack/react-query';
import { timesheetApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

/** @registry Employees whose primary office matches, for timesheet-report pickers. */
export function useTimesheetUsersForOffice(
  officeId: number | null | undefined,
  onlyMyTeam: boolean,
) {
  return useQuery({
    queryKey: queryKeys.timesheets.usersForOffice(officeId ?? -1, onlyMyTeam),
    queryFn: ({ signal }) =>
      timesheetApiClient.getTimesheetUsersForOffice(
        officeId!,
        onlyMyTeam,
        toCancelToken(signal),
      ),
    enabled: officeId != null && officeId > 0,
    meta: { errorContext: 'timesheet office users' },
  });
}
